module.exports = __webpack_public_path__ + "static/media/86.cd70f9e1.jpg";